"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.onModalMount = void 0;
const currentRouteObj_1 = __importDefault(require("root/src/client/logic/route/selectors/currentRouteObj"));
const otherModuleOnEnter_1 = __importDefault(require("root/src/client/logic/api/thunks/otherModuleOnEnter"));
const onModalMount = (moduleId) => (dispatch, getState) => {
    const routeObj = (0, currentRouteObj_1.default)(getState());
    (0, otherModuleOnEnter_1.default)({ moduleId, nextRouteObj: routeObj })(dispatch, getState);
};
exports.onModalMount = onModalMount;
